import { Fragment } from 'react';

import { ShopsDropdown } from '~/components';

import { RemoteAppointmentInformation } from '../components';
import { PATH_NAMES } from '../constants';
import {
  PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
  EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
  PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE_WITHOUT_SHOP_PAGE,
} from './progress-bar-items.config';
import { services } from '~/ocab-services/services.constant';

export const config = {
  v2: {
    appointment: {
      name: 'Home Design',
    },
    ReviewForm: {
      shopDetails: {
        title: 'Service provided by',
      },
    },
    AboutYou: {
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
              <p>
                {'We will call you on this number at the time of your appointment.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
    additionalShopTitle: 'Our Partners host virtual appointments by video or phone call. You can book at any shop or select one nearer to you.',
    searchResultTitle: 'Shops offering virtual appointments near',
    searchResultDescription: 'If you can\'t find a slot at a shop nearby, you can book at any other shop.',
    shopAddress: 'Virtual Service',

    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    EDIT_PROGRESS_BAR_ITEMS: EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    shopsNextPath: PATH_NAMES.SELECT_DATE,
    selectDatePrevPath: PATH_NAMES.SELECT_SHOP,
    editShopNextPath: PATH_NAMES.EDIT_DATE,
    editDatePrevPath: PATH_NAMES.EDIT_SHOP,
    selectDateTitle: 'Select a date',
    subtitleComponent: ({ className, secondLineClassName }) => (
      <div className={className}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
        <p className={secondLineClassName}>If you can&apos;t find a preferred slot at your selected shop please try another one.</p>
      </div>
    ),
    ShopsDropdown,
    hideFilters: true,
  },
  v3: {
    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE_WITHOUT_SHOP_PAGE,
    EDIT_PROGRESS_BAR_ITEMS: [],
    shopsNextPath: PATH_NAMES.SELECT_DATE,
    editShopNextPath: PATH_NAMES.EDIT_DATE,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    hideChosenPartner: true,
    selectDateTitle: 'Select a date for your virtual appointment',
    AboutYou: {
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    getSelectDateExternalPrevPath: (envConfig, appointmentTypeId) => envConfig.services[services.HOME_DESIGN.name].appointmentTypes[appointmentTypeId].landingPageUrl,
    subtitleComponent: ({ classNameForSubtitleWithLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>We carry out our virtual appointments wherever you are, at a time that works for you.</p>
      </div>
    ),
    hideFilters: false,
    isPartnerSelectionEnabled: false,
    BookingReview: {
      hideShopDetails: true,
      hidePartnerDetails: true,
      icsEvent: {
        isServiceNameIncludedToAppointmentTypeName: false,
      },
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
  },
  v4: {
    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE_WITHOUT_SHOP_PAGE,
    EDIT_PROGRESS_BAR_ITEMS: [],
    shopsNextPath: PATH_NAMES.SELECT_DATE,
    editShopNextPath: PATH_NAMES.EDIT_DATE,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    hideChosenPartner: true,
    selectDateTitle: 'Select a date for your virtual consultation appointment',
    AboutYou: {
      TimeSlot: {
        title: 'Your consultation appointment time',
      },
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    getSelectDateExternalPrevPath: (envConfig, appointmentTypeId) => envConfig.services[services.HOME_DESIGN.name].appointmentTypes[appointmentTypeId].landingPageUrl,
    subtitleComponent: ({ classNameForSubtitleWithLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>We carry out our virtual appointments wherever you are, at a time that works for you.</p>
      </div>
    ),
    hideFilters: false,
    isPartnerSelectionEnabled: false,
    BookingReview: {
      hideShopDetails: true,
      hidePartnerDetails: true,
      icsEvent: {
        isServiceNameIncludedToAppointmentTypeName: false,
      },
    },
  },
};
